import { render, staticRenderFns } from "./AdminES.vue?vue&type=template&id=61ab5500"
import script from "./AdminES.vue?vue&type=script&lang=js"
export * from "./AdminES.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports